import { Link } from 'react-router-dom';
import { FileTextIcon } from 'lucide-react';
import type { StrategicBriefSource } from '@cdf/api-client-react';

import { Badge } from '@/components/ui/badge';

export type StrategicBriefChipItem = Pick<StrategicBriefSource, 'briefId' | 'recordName' | 'deepLink' | 'truncated'>;

/** Shows which strategic briefs the AI used, each linking to its brief tab. */
export function StrategicBriefChips({ sources, className }: { sources: ReadonlyArray<StrategicBriefChipItem> | null | undefined; className?: string }) {
  if (!sources || sources.length === 0) return null;
  return (
    <div className={['flex flex-wrap items-center gap-1.5', className].filter(Boolean).join(' ')} aria-label="Strategic briefs used by the AI">
      {sources.map((source) => (
        <Badge key={source.briefId} variant="outline" className="max-w-full gap-1 font-normal">
          <FileTextIcon className="size-3 shrink-0" aria-hidden="true" />
          <Link
            to={source.deepLink}
            className="truncate underline-offset-2 hover:underline focus-visible:underline"
            title={source.truncated ? 'Only part of this brief fitted the AI size limit.' : undefined}
          >
            Used strategic brief · {source.recordName}
          </Link>
        </Badge>
      ))}
    </div>
  );
}
